/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import logo from './../../common/assets/img/AMIG-logo-withTagline.png';
import allstate_logo from './../../common/assets/img/allstate-logo.png';
import appSettings from '../../appSettings';
import './ShopFloorHeader.scss';
import { MenuButton, MobileMenuButton } from '..';
import { IconButton, Box, Link } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { setLoadingState } from '../../actions/actions';
import { getCurrentPrismId, getCurrentPrismEnrollment } from '../../common/utilities/CommonHelperUtil';
import MarketingRedirect from '../common/MarketingRedirect';
import { gwLinkRedirect } from '../../common/services/proxyServices';
import { useHistory } from 'react-router-dom';
import constants from '../../constants';

const ShopfloorHeader = ({ handleChange, toggleDropdown, toggleChatbot, showMinifiedHeader, setNotificationMenuOpen, isNotificationMenuOpen, navAgencyManagement, showReportingCommonModal }) => {
  const { instance } = useMsal();
  const contactData = useSelector(state => state.contact);
  const loading = useSelector(state => state.loading);
  const enrollments = useSelector(state => state.enrollments);
  const customLinks = useSelector(state=> state.customLinks);
  const notifications = useSelector(state => state.webAlerts);
  const agentAMSuitePreference = useSelector(state=> state.selectedProfile.amsuitePreference);
  const legacyProfileId = useSelector(state=> state.selectedProfile.lpId);
  const [openHeaderMenu, setOpenHeaderMenu] = useState(false);
  const [hasNotifications, setHasNotification] = useState(notifications.length > 0);
  const [openMobileNotificationMenu, setOpenMobileNotificationMenu] = useState(false);
  const [redirectURL] = useState('');
  const displayName = `${contactData.firstName} ${contactData.lastName}`;
  const username = enrollments.length > 0 ? getCurrentPrismId(enrollments) : '';  
  const domain = enrollments.length > 0 ? getCurrentPrismEnrollment(enrollments)?.domain : '';  
  const history = useHistory();
  const message = contactData.firstName + " " + contactData.lastName + "\t" + legacyProfileId;
  const encodedMessage = encodeURIComponent(message);
 

  useEffect(() => {
    setLoadingState(true);
    if (Object.keys(contactData).length !== 0) {
      setLoadingState(false);
    }
    setHasNotification(notifications.length > 0);
  }, [contactData, loading, notifications]);
  
  useEffect(() => {
    if(window.innerWidth < 1265 && isNotificationMenuOpen === true) {
      setOpenMobileNotificationMenu(isNotificationMenuOpen);
    }
  }, [isNotificationMenuOpen]);

  const handleNavigate = async () => {
    if (username) {
        const newURL = agentAMSuitePreference !== undefined && agentAMSuitePreference.toLowerCase() !== constants.amsuite ? await gwLinkRedirect(username, null, false, true) : await gwLinkRedirect(username, null, true, false);
        return newURL;
    }
    return '';
  };

  function getLinks(links, linkCategory){
    return links.filter(function(link) {
      return link.category === linkCategory;
    });
  };

  function getUpdatedLinks(linkData){
    return linkData.map(item=>(
      {
        name: item.display,
        link: item.url,
        open: '_blank',
      }
    ));
  };

  async function populateMenuLinks() {
    wantToMenuLinkData.push(
        { 
            name: 'Go to ' + constants.AMSUITE_PC, 
            link: redirectURL, 
            open: '_self'
        },
        { 
            name: constants.addUsername, 
            link: '/add-user', 
            open: '_self' 
        },
        { 
            type: constants.separator 
        },
        { 
            name: 'Chat', 
            action: toggleChatbot, 
            type: 'green-menu-links', 
            icon: 'livechat', 
            open: '_blank' 
        }
    );
}

  const wantToMenuLinkData = [{ name: 'Start a quote', link: '/', action: toggleDropdown , open:'_self'  }];
  wantToMenuLinkData.push(...getUpdatedLinks(getLinks(customLinks, constants.WANTTOMENULINK)));
  const agentToolsData = getUpdatedLinks(getLinks(customLinks, constants.AGENTTOOLS));
  const getHelpLinkData = getUpdatedLinks(getLinks(customLinks, constants.GETHELP));

  populateMenuLinks();
  agentToolsData.push({ type: constants.separator },{ name: 'Chat', action: toggleChatbot, type: 'green-menu-links', icon: 'livechat', open: '_blank' });
  getHelpLinkData.push({ type: constants.separator },{ name: 'Chat', action: toggleChatbot, type: 'green-menu-links', icon: 'livechat', open: '_blank' });

  agentToolsData.map(async item => {
    if (item.name?.toLowerCase().includes(constants.agencyManagement)) {
      item.action = () => navAgencyManagement(item);
    }
    if (item.name?.toLowerCase().includes(constants.reports)) {
      item.action = () => showReportingCommonModal();
    }
    else if (item.name && item.name.toLowerCase().includes(constants.policyDocumentsPortal)) {
      item.link = `${appSettings.AGENT_REDIRECT_URL}`;
    }
    else if (item.name?.toLowerCase().includes(constants.marketing)) {
      item.link = await MarketingRedirect(contactData.emailAddress, item.link);
    }
    return item;
  });

  const menu = [
    {
      name: constants.iWantTo,
      menuItems: wantToMenuLinkData
    },
    {
      name: constants.agentTools,
      menuItems: agentToolsData
    }
  ];

  const getHelpMenu = [{
      name: constants.getHelp,
      menuItems: getHelpLinkData
    }
  ];

  var currentUser = enrollments.find(item => item.prismId === username);
  if (currentUser) {
    const indexValue = enrollments.indexOf(currentUser);
    enrollments.splice(indexValue, 1);
    enrollments.unshift(currentUser);
  };

  const loginId = [
    {
      name: displayName,
      subname: username,
      menuType: 'wide',
      menuItems: [
        ...(enrollments.length > 1
          ? enrollments.map((data) => ({
             name: data.prismId,
             action: username === data.prismId ? undefined : handleChange,
             style:  username === data.prismId ? 'bold' : undefined
            }))
          : []),
        ...((enrollments.length > 1 || showMinifiedHeader)?[{ type: constants.separator },
        { name: constants.addUsername, link: '/add-user', type: 'add-user-link', icon: 'plus-icon', open:'_self' },
        { type: constants.separator }] : []),
        { name: constants.logout, action: logout }
      ]
    }
  ];
  

  const avatarMenu = [
    {
      name: displayName,
      icon: 'human-icon',
      menuType: 'wide',
      menuItems: [
        { name: displayName, type: constants.activeUser },
        { type: constants.separator },
        { name: constants.accountPreferences, link: '/account-preferences', type: 'spaced-menu-links', open:'_self' },
        { type: constants.separator },
        { name: constants.logout, action: logout }]
    }
  ];

  function logout() {
    instance.logout();
  }
  
  const notificationMenu = [
    {
      name: constants.notifications,
      icon: 'bell-icon',
      menuType: 'wide',
      menuItems: notifications
    }
  ];

  const toggleSidebar = useCallback((sidebarType) => {
    switch (sidebarType) {
      case constants.account:
        setOpenHeaderMenu(prev => !prev);
        break;
      case constants.notification:
        setOpenMobileNotificationMenu(prev => !prev);
        break;
      default:
        setOpenHeaderMenu(false);
        setOpenMobileNotificationMenu(false);
        break;
    }
  });

  const handleLogoClick = (event) => {
    if (history.location.pathname !== '/') {
     window.location.replace('/');
    }
  };

  return (
    <>
    <MobileMenuButton showDrawer={openHeaderMenu} usernames={loginId[0].menuItems} notificationIcon={notificationMenu[0].icon} menu={(showMinifiedHeader)?getHelpMenu:menu.concat(getHelpMenu)} showMinifiedHeader={showMinifiedHeader} toggleSidebar={toggleSidebar} toggleDropdown={toggleDropdown} toggleChatbot={toggleChatbot} hasNotifications={hasNotifications} ></MobileMenuButton>
    <MobileMenuButton showDrawer={openMobileNotificationMenu} notifications={notificationMenu[0].menuItems} notificationIcon={notificationMenu[0].icon} showMinifiedHeader={showMinifiedHeader} toggleSidebar={toggleSidebar} toggleDropdown={toggleDropdown} toggleChatbot={toggleChatbot} hasNotifications={hasNotifications} ></MobileMenuButton>
    <header className='header-content shopfloor-header'>
      <Box className='custom-header-container'>
        <Box className='header-logo-container'>
          <Link           
            aria-label='American Modern Logo'      
            onClick={handleLogoClick}
          >
            <img
              className='american-mod-logo'
              src={(domain !== null && domain.toLowerCase().includes('allstate')) ? allstate_logo : logo}
              alt='American Modern Logo'
            />
          </Link>
        </Box>
        <Box className='header-button-container'>
          <div className='menu-header-button'>
            {!showMinifiedHeader &&<MenuButton menu={menu} toggleDropdown={toggleDropdown} handleNavigate={handleNavigate} natPayEncodedMessage={encodedMessage}/>}                                                                                          
            <MenuButton menu={getHelpMenu} toggleDropdown={toggleDropdown} />
          </div>
          <div className='header-notification-icon'>
            {!showMinifiedHeader && <MenuButton menu={notificationMenu} setOpenMenu={setNotificationMenuOpen} openMenu={isNotificationMenuOpen} hasNotifications={hasNotifications}  />}
          </div>
          {!showMinifiedHeader && <div className='mobile-notification-icon'>
            <div className={hasNotifications ? 'badge' : ''}></div>
            <IconButton onClick={() => toggleSidebar(constants.notification)}>
              <img
                src={require('../../common/assets/img/bell-icon.png')}
                alt="Bell Icon"
              />
            </IconButton>
          </div>}
          <div className='header-avatar-icon'>
            <MenuButton menu={avatarMenu} />
          </div>
          <div className='loginId-button'>
            <MenuButton menu={loginId} />
          </div>
          <div className='hamburger-header-icon'>
          <IconButton onClick={() => toggleSidebar(constants.account)}>
            <img
              src={require('../../common/assets/img/hamburger-icon.png')}
              alt='menu'
            />
          </IconButton>
          </div>
        </Box>
      </Box>
    </header>
  </>
  );
}

export default ShopfloorHeader;
